/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actions from "store/actions/das";
import IDas from "Types/Das";

export interface DasState {
	items: IDas[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: DasState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false, send: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_DASES: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_DASES_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_DASES_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.GENERATE_DASES: {
			return {
				...state,
				loading: { import: true },
				errors: initialState.errors
			};
		}
		case actions.GENERATE_DASES_SUCCESS: {
			return {
				...state,
				loading: { import: false }
			};
		}
		case actions.GENERATE_DASES_FAILED: {
			return {
				...state,
				loading: { import: false },
				errors: payload
			};
		}
		case actions.GENERATE_DASES: {
			return {
				...state,
				loading: { send: true },
				errors: initialState.errors
			};
		}
		case actions.GENERATE_DASES_SUCCESS: {
			return {
				...state,
				loading: { send: false }
			};
		}
		case actions.GENERATE_DASES_FAILED: {
			return {
				...state,
				loading: { send: false },
				errors: payload
			};
		}
		case actions.REFRESH_DAS: {
			return {
				...state,
				loading: { ...state.loading, refresh: true },
				errors: initialState.errors
			};
		}
		case actions.REFRESH_DAS_SUCCESS: {
			return {
				...state,
				loading: { ...state.loading, refresh: false }
			};
		}
		case actions.REFRESH_DAS_FAILED: {
			return {
				...state,
				loading: { ...state.loading, refresh: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
